import { popupModel } from '@_entities/system';
import { HTMLParse } from '@_shared/libs';
import { PromotionPopup } from '@_shared/ui/Popup';
import { handleOnPopupButtonClick } from '../../libs';

interface TextPopupProps {
	popup: popupModel.ITextPopup;
	handleClose: () => void;
}

export function TextPopup({ popup, handleClose }: TextPopupProps) {
	return (
		<PromotionPopup.Container closePopup={handleClose}>
			{popup.deleteButtonEnabled && <PromotionPopup.CloseIcon onClose={handleClose} />}
			<PromotionPopup.TextContainer>
				{popup.body.text.title && (
					<PromotionPopup.Title>{popup.body.text.title}</PromotionPopup.Title>
				)}
				{popup.body.text.subText1 && (
					<PromotionPopup.SubText>
						{HTMLParse(popup.body.text.subText1)}
					</PromotionPopup.SubText>
				)}
				{popup.body.text.subText2 && (
					<PromotionPopup.Warning>
						{HTMLParse(popup.body.text.subText2)}
					</PromotionPopup.Warning>
				)}
			</PromotionPopup.TextContainer>

			<PromotionPopup.ButtonContainer>
				{popup.buttons.map((button) => (
					<PromotionPopup.Button
						type={button.color === 'orange' ? 'confirm' : 'deny'}
						onClick={() => {
							handleOnPopupButtonClick(button, handleClose, popup.id);
						}}
					>
						{button.text}
					</PromotionPopup.Button>
				))}
			</PromotionPopup.ButtonContainer>
		</PromotionPopup.Container>
	);
}
